/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react';
import { Row, Col, Image, Space } from "antd";
import clsx from 'clsx';
import customStyles from "../../../../../assets/styles/customStyles";
import { NavLink } from "react-router-dom";
import DropDown from "../../../../../assets/images/icon_menus/Drop Down.svg";
import DropUp from "../../../../../assets/images/icon_menus/Drop Up.svg";
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import DateIcon from "../../../../Shared/components/Icons/Date";
import moment from 'moment';
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { useSelector } from "react-redux";
import { FilterSelect } from "../../../../Shared/components/CustomSelect";
import FilterIcon from "../../../../../assets/images/icon_actions/Filter Icon.svg";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import { TextField } from "@mui/material";
import { checkComponentPermission, checkCRUDPermission, idNamingConversion } from '../../../../../helpers/utilities';
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { Link } from "react-router-dom";
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";
import usePrevious from "../../../../Shared/components/Previous";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { FilterProductGroup } from "./FilterProductGroup";
import FilterReset from "../../../../../assets/images/icon_actions/FilterReset.svg";



const TopBar = (props) => {
    const { title, handleCreate, handleDatesParent, handleStatus, topBarView, topBar, handleType,
        onImportVisible, handleFilter, roleManagement, loadImportExportData, handleSideFilter, productApi } = props;
    const { customerDetails } = useSelector(state => state.salesManagementReducer);
    const { customerGroupdetails } = useSelector(state => state.salesSetupReducer);
    const { myProductdetails } = useSelector(state => state.productProductReducer);
    const [picker, setPicker] = useState(false);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [status, setStatus] = useState('active');
    const [, setType] = useState('ALL');
    const [customerGroupId, setCustomerGroupId] = useState('');
    const [customerId, setCustomerId] = useState('');
    const [productId, setProductId] = useState('');
    const [search, setSearch] = useState('');
    const timeoutRef = useRef(null);
    const prevSearch = usePrevious(search);
    const [iconAnimation, setIconAnimation] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false)


    const handleDates = (value, reset = false) => {
        if ((value[0] !== null && value[1] !== null) || reset) {
            handleDatesParent(value);
        }
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                handleFilter(customerId, customerGroupId, productId, search);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    handleFilter(customerId, customerGroupId, productId, search);
                }, 500);
            }
        }
    }, [search]);

    const handlePicker = (picker) => {
        setPicker(picker);
        setStartDate(null);
        setEndDate(null);
        if (!picker) {
            handleDates([null, null], true);
        }
    }

    const handleTypeChange = (value) => {
        setCustomerGroupId('');
        setCustomerId('');
        setType(value);
        handleType(value);
        handleFilter('', '');
    }

    const handleFIlterOpen = () => {
        if (topBar?.customerGroupId || topBar?.customerId || topBar?.productGroupId || topBar?.productId || (topBar?.startDate && topBar?.endDate)) {
            handleSideFilter({ type: 'All' });
        } else {
            setFilterOpen(true);
        }
    }



    const classes = customStyles();

    return (
        <>
            <Row className={clsx(classes.priceTopbar)}>
                <Col xxl={4} xl={4} lg={4} md={4} sm={24} xs={24}>
                    {
                        roleManagement !== '' && !topBarView && checkComponentPermission('Customer Sales Price', 'Action', 'Search') &&
                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                            <TextField autoComplete='one-time-code'
                                placeholder='Search'
                                type='search'
                                fullWidth
                                onChange={(e) => setSearch(e.target.value)}
                                className={classes.comInput}
                                variant={'standard'}
                                id={idNamingConversion('Search', 'salesPrice', 'TextField')}
                                onFocus={() => setIconAnimation(true)}
                                onBlur={() => setIconAnimation(false)}
                            />
                            <Image
                                src={SearchIcon}
                                preview={false}
                            />
                        </div>
                    }
                </Col>
                <Col xxl={topBarView ? 24 : 20} xl={topBarView ? 24 : 20} lg={topBarView ? 24 : 20} md={topBarView ? 24 : 24} sm={topBarView ? 24 : 24} xs={topBarView ? 24 : 24}
                    className={clsx(classes.textAlignRight, classes.customerLabelNone, classes.vertiCalScrollOverFlowParent)}>
                    <div className={clsx(classes.vertiCalScrollOverFlow, classes.customFilterSales)}>
                        <Space size={[20, 20]} direction="horizontal" align="center">
                            {/* <div className={clsx(classes.fillterDropdown, classes.customFilterNone)}>
                                {
                                    roleManagement !== '' && topBarView && checkComponentPermission('Customer Sales Price', 'Action', 'Customer specification Filter') &&
                                    <>
                                        <FormControl
                                            className={clsx(classes.dropDownPointer, classes.customRadioButton)}
                                            variant={'standard'}
                                            fullWidth>
                                            <RadioGroup
                                                row
                                                value={type}
                                                id={idNamingConversion('Customer specification Filter', 'salesPrice', 'Radio')}
                                                onChange={(e) => handleTypeChange(e.target.value)}>
                                                <FormControlLabel value="ALL" control={<Radio
                                                    checkedIcon={<UnSelectedIcon />}
                                                    icon={<SelectedIcon />}
                                                />} label="All" />
                                                <FormControlLabel value="SPECIFIC" control={<Radio
                                                    checkedIcon={<UnSelectedIcon />}
                                                    icon={<SelectedIcon />}
                                                />} label="Customer Specific" />
                                                <FormControlLabel value="GROUP" control={<Radio
                                                    checkedIcon={<UnSelectedIcon />}
                                                    icon={<SelectedIcon />}
                                                />} label="Group" />
                                            </RadioGroup>
                                        </FormControl>
                                        {
                                            type !== 'ALL' && <>
                                                {
                                                    type === 'GROUP' ?
                                                        <AutoCompleteComponent
                                                            customLabel={"All Customers Group"}
                                                            heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                            details={customerGroupdetails}
                                                            parentValue={customObject(customerGroupdetails, customerGroupId)}
                                                            position={"bottom"}
                                                            id={idNamingConversion('All Customers Group', 'salesPrice', 'DropDown')}
                                                            customClasses={classes.customFilterNone}
                                                            variant={'outlined'}
                                                            onChangeText={(data) => {
                                                                if (data === '') {
                                                                    setCustomerGroupId('');
                                                                    handleFilter(customerId, '', productId);
                                                                }
                                                            }}
                                                            onChange={(data) => {
                                                                setCustomerGroupId(data.id) // help to set the value
                                                                handleFilter(customerId, data.id, productId);
                                                            }}
                                                        /> : <AutoCompleteComponent
                                                            customLabel={"All Customers"}
                                                            heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                            details={customerDetails}
                                                            id={idNamingConversion('All Customers', 'salesPrice', 'DropDown')}
                                                            parentValue={customObject(customerDetails, customerId)}
                                                            position={"bottom"}
                                                            customClasses={classes.customFilterNone}
                                                            variant={'outlined'}
                                                            onChangeText={(data) => {
                                                                if (data === '') {
                                                                    setCustomerId('');
                                                                    handleFilter('', customerGroupId, productId);
                                                                }
                                                            }}
                                                            onChange={(data) => {
                                                                setCustomerId(data.id) // help to set the value
                                                                handleFilter(data.id, customerGroupId, productId);
                                                            }}
                                                        />
                                                }
                                            </>
                                        }
                                    </>
                                }
                            </div> */}
                            {
                                roleManagement !== '' && checkComponentPermission('Customer Sales Price', 'Action', 'Product Filter') &&
                                <AutoCompleteComponent
                                    customLabel={"All Product"}
                                    heads={[{ 'key': 'productName', 'name': 'Product Name' },
                                    { 'key': 'productId', 'name': 'Product ID' },
                                    { 'key': 'code', 'name': 'Product Code' }]}
                                    details={myProductdetails}
                                    parentValue={customObject(myProductdetails, productId)}
                                    customClasses={clsx(classes.customWidth172P, classes.customFilterNone)}
                                    position={"bottom"}
                                    id={idNamingConversion('All Product', 'salesPrice', 'DropDown')}
                                    variant={'outlined'}
                                    onChangeText={(data) => {
                                        if (data === '') {
                                            setProductId('');
                                            handleFilter(customerId, customerGroupId, '');
                                        }
                                    }}
                                    searchType={(s) => productApi(s)}
                                    onChange={(data) => {
                                        setProductId(data.id);
                                        handleFilter(customerId, customerGroupId, data.id);
                                    }}
                                />
                            }
                            {
                                roleManagement !== '' && checkComponentPermission('Customer Sales Price', 'Page', 'Date Filter') &&
                                <div className={clsx(classes.dateFilterwidth, classes.width250, classes.customFilterNone)}>
                                    <Row>
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <NavLink id={idNamingConversion('Date Filter', 'salesPrice', 'Link')} to={'#'} onClick={() => handlePicker(!picker)}
                                                className={clsx(classes.textAlignLeft, classes.dateFilter, classes.dropDownBorder, classes.dropDownWidth, classes.margint0, classes.dropDownPointer)}>
                                                Date Filter <Image
                                                    src={picker ? DropUp : DropDown}
                                                    preview={false} />
                                            </NavLink>
                                        </Col>
                                        {
                                            picker && <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                                <div className={clsx(classes.dateFilterdateAdjust)}>
                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                        <DesktopDatePicker
                                                            fullWidth
                                                            slots={{
                                                                openPickerIcon: DateIcon
                                                            }}
                                                            views={['year', 'month', 'day']}
                                                            allowKeyboardControl={false}
                                                            value={startDate}
                                                            label="From Date"
                                                            InputProps={{
                                                                classes: {
                                                                    input: classes.textFieldColor,

                                                                },
                                                                //inputProps: { value: moment(startDate).format('DD/MM/YYYY'), readOnly: false }
                                                            }}
                                                            format="dd/MM/yyyy"
                                                            onChange={(newValue) => {
                                                                handleDates([moment(newValue).format("YYYY-MM-DD"), endDate]);
                                                                setStartDate(newValue);
                                                            }}
                                                            slotProps={{
                                                                textField: {
                                                                    id: idNamingConversion('From Date', 'salesPrice', 'TextField'),
                                                                    autoComplete: 'one-time-code'
                                                                },
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                        <DesktopDatePicker
                                                            fullWidth
                                                            slots={{
                                                                openPickerIcon: DateIcon
                                                            }}
                                                            views={['year', 'month', 'day']}
                                                            allowKeyboardControl={false}
                                                            value={endDate}
                                                            minDate={new Date(startDate)}
                                                            label="To Date"
                                                            InputProps={{
                                                                classes: {
                                                                    input: classes.textFieldColor
                                                                },
                                                                //inputProps: { value: moment(endDate).format('DD/MM/YYYY'), readOnly: false }
                                                            }}
                                                            format="dd/MM/yyyy"
                                                            onChange={(newValue) => {
                                                                handleDates([startDate, moment(newValue).format("YYYY-MM-DD")]);
                                                                setEndDate(newValue);
                                                            }}
                                                            slotProps={{
                                                                textField: {
                                                                    id: idNamingConversion('To Date', 'salesPrice', 'TextField'),
                                                                    autoComplete: 'one-time-code'
                                                                },
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                            </Col>
                                        }
                                    </Row>
                                </div>
                            }
                            {
                                roleManagement !== '' && topBarView && checkComponentPermission('Customer Sales Price', 'Action', 'Status Filter') &&
                                <FilterSelect
                                    parentClasses={clsx(classes.dateFilterwidth, classes.width125)}
                                    customClasses={clsx(classes.dropDownBorder, classes.dropDownWidth, classes.margint0, classes.dropDownPointer)}
                                    details={[{ slug: "", label: "All" }, { slug: "active", label: "Active" }, { slug: "inactive", label: "In-active" }]}
                                    onChange={(e) => { setStatus(e.target.value); handleStatus(e.target.value) }}
                                    defaultValue={status}
                                    id={idNamingConversion('All', 'salesPrice', 'DropDown')}
                                    heads={['slug', 'label']}
                                />
                            }
                            {
                                roleManagement !== '' && topBarView && checkComponentPermission('Customer Sales Price', 'Action', 'Export') &&
                                <NavLink
                                    to="#"
                                    id={idNamingConversion('Export', 'salesPrice', 'Link')}
                                    onClick={() => { loadImportExportData('Customer Sales Price'); }}
                                    className={clsx(classes.customLink,)}>
                                    <Image
                                        src={ExportIcon}
                                        preview={false}
                                        className={clsx(classes.antImage)}
                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                </NavLink>
                            }
                            {
                                roleManagement !== '' && topBarView && checkComponentPermission('Customer Sales Price', 'Action', 'Import') &&
                                <NavLink
                                    to="#"
                                    id={idNamingConversion('Import', 'salesPrice', 'Link')}
                                    onClick={() => onImportVisible(true)}
                                    className={clsx(classes.customLink, classes.width100PCustomer)}>
                                    <Image
                                        src={ImportIcon}
                                        preview={false}
                                        className={clsx(classes.antImage)}
                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                </NavLink>
                            }
                            {
                                roleManagement !== '' && topBarView && checkCRUDPermission('Customer Sales Price', 'create', 'Sales') && <NavLink
                                    to="#"
                                    onClick={() => handleCreate()}
                                    id={idNamingConversion('Create', 'salesPrice', 'Link')}
                                    className={clsx(classes.customLink)}>
                                    <Image
                                        src={AddIcon}
                                        preview={false}
                                        className={clsx(classes.antImage)}
                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold, classes.textCapital)}>Create {title}</span>
                                </NavLink>
                            }
                            {
                                !topBarView &&
                                <Link id={idNamingConversion('View All Prices', 'salesPrice', 'Link')} to={`/sales/setup/sales-price`} className={clsx(classes.color, classes.bold)}>
                                    <Image src={ViewIcon} preview={false} /> <span>View All Prices</span>
                                </Link>
                            }
                            {
                                roleManagement !== '' && topBarView &&
                                (checkComponentPermission('Customer Sales Price', 'Action', 'Customer specification Filter') ||
                                    checkComponentPermission('Customer Sales Price', 'Action', 'Product Filter') ||
                                    checkComponentPermission('Customer Sales Price', 'Page', 'Date Filter')) && <>
                                    <NavLink
                                        to="#"
                                        className={clsx(classes.customLink)}
                                        onClick={() => handleFIlterOpen()}>
                                        {
                                            topBar?.customerGroupId || topBar?.customerId || topBar?.productGroupId || topBar?.productId || (topBar?.startDate && topBar?.endDate) ?
                                                <>
                                                    <Image
                                                        src={FilterReset}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold, classes.fwMedium)}>Reset Filter</span>
                                                </>
                                                : <>
                                                    <Image
                                                        src={FilterIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold, classes.fwMedium)}>Filter</span>
                                                </>
                                        }
                                    </NavLink>
                                </>
                            }
                        </Space>
                    </div>
                </Col>
            </Row>
            <PrimaryDrawer
                open={filterOpen}
                title={'Filter and Product Group'}
                width={"360px"}
                handleClose={() => setFilterOpen(false)}
                className={clsx(classes.closeBackGround, classes.width100MaintainPrice)}
                component={
                    <FilterProductGroup
                        {...props}
                        topBarView={topBarView}
                        customerDetails={customerDetails}
                        myProductdetails={myProductdetails}
                        handleCloseMobile={() => setFilterOpen(false)}
                        customObject={(details, id) => customObject(details, id)}
                        customerGroupdetails={customerGroupdetails}
                        customerId={customerId}
                        handleTypeChange={(v) => handleTypeChange(v)}
                        handleSideFilter={(data) => { setFilterOpen(false); handleSideFilter(data) }}
                    />
                }
            />
        </>

    )
};

export default TopBar;
